export default __webpack_public_path__ + "static/media/jcb-single.4be05fa3.svg";